import React from 'react';
export function Footer() {
  return <footer className="bg-white pt-16 pb-8 brutal-border border-l-0 border-r-0 border-b-0" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-54">
          <div className="md:col-span-2" data-id="element-55">
            <span className="font-archivo text-6xl tracking-tighter block mb-6" dir="ltr" data-id="element-56">
              REBEL
            </span>
            <p className="text-xl font-bold max-w-sm" data-id="element-57">
              מותג אופנת רחוב ישראלי שבועט במוסכמות. לא מתנצלים, לא מתפשרים.
            </p>
          </div>

          <div data-id="element-58">
            <h4 className="text-2xl font-black mb-6 border-b-4 border-black inline-block pb-1" data-id="element-59">
              ניווט
            </h4>
            <ul className="space-y-4 text-xl font-bold" data-id="element-60">
              <li data-id="element-61">
                <a href="#DROPS" className="hover:text-magenta transition-colors" data-id="element-62">
                  דרופים
                </a>
              </li>
              <li data-id="element-63">
                <a href="#חנות" className="hover:text-electric transition-colors" data-id="element-64">
                  חנות
                </a>
              </li>
              <li data-id="element-65">
                <a href="#אודות" className="hover:text-acid transition-colors" data-id="element-66">
                  אודות
                </a>
              </li>
              <li data-id="element-67">
                <a href="#קהילה" className="hover:text-magenta transition-colors" data-id="element-68">
                  קהילה
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-69">
            <h4 className="text-2xl font-black mb-6 border-b-4 border-black inline-block pb-1" data-id="element-70">
              סושיאל
            </h4>
            <div className="flex flex-wrap gap-4" data-id="element-71">
              {['INSTAGRAM', 'TIKTOK', 'TWITTER'].map(social => <a key={social} href="#" className="brutal-btn bg-black text-white px-4 py-2 text-sm font-archivo hover:bg-acid hover:text-black" dir="ltr" data-id="element-72">
                  {social}
                </a>)}
            </div>
          </div>
        </div>

        <div className="border-t-8 border-black pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-73">
          <p className="text-xl font-bold" data-id="element-74">© 2026 REBEL. כל הזכויות שמורות.</p>
          <div className="flex gap-4 text-lg font-bold" data-id="element-75">
            <a href="#" className="hover:underline" data-id="element-76">
              תקנון
            </a>
            <a href="#" className="hover:underline" data-id="element-77">
              פרטיות
            </a>
          </div>
        </div>
      </div>
    </footer>;
}